import {NgModule} from '@angular/core';
import {AdminDistrictsComponent} from './districts/adminDistricts.component';
import {AdminDistrictComponent} from './districts/adminDistrict.component';
import {AdminFilesComponent} from './files/admin.files.component';
import {AdminOptionsComponent} from './options/admin.options.component';
import {AdminTokensComponent} from './tokens/admin.tokens.component';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AdminViewComponent} from './view/admin-view.component';
import {RouterModule} from '@angular/router';
import {AdminFeaturesComponent} from './features/adminFeatures.component';
import {AdminFeatureComponent} from './features/adminFeature.component';
import {CreateDistrictComponent} from './districts/createDistrict.component';
import {MongoComponent} from './mongo/mongo.component';
import {NgChartsModule} from 'ng2-charts';

@NgModule({
  bootstrap: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    RouterModule,
    NgChartsModule
  ],
  declarations: [
    AdminViewComponent,
    AdminDistrictComponent,
    AdminDistrictsComponent,
    AdminFeaturesComponent,
    AdminFeatureComponent,
    AdminFilesComponent,
    AdminOptionsComponent,
    AdminTokensComponent,
    CreateDistrictComponent,
    MongoComponent
  ],
  exports: [
    AdminViewComponent,
    AdminDistrictComponent,
    AdminDistrictsComponent,
    AdminFeaturesComponent,
    AdminFeatureComponent,
    AdminFilesComponent,
    AdminOptionsComponent,
    AdminTokensComponent,
    CreateDistrictComponent,
    MongoComponent
  ]
})
export class AdminModule {

}
